import React from 'react';
import Index from './Index';
import TreasuryView from '../components/views/treasury/TreasuryView';
import { modules } from '../config/const';

function TreasuryPage() {
  return <Index content={TreasuryView} module={modules.Treasury} />;
}

export default TreasuryPage;

